import { ShimmerEffect } from "@/design-system/Atoms";

const VideosTabShimmer = () => {
  return (
    <div className="flex flex-col rounded-2xl backdrop-blur-md bg-white p-6 relative">
      <div>
        <div className="flex justify-between items-center mb-6">
          <ShimmerEffect className="h-[31.99px] w-[31.99px] me-6" />
          <ShimmerEffect className="h-[60px] w-full" />
        </div>

        <div className="relative flex flex-col items-start pl-14 pr-18 mb-6">
          <ShimmerEffect className="lg:w-[364.12px] md:w-[224.12px] sm:w-[120.12px] h-[191.99px] mb-2" />
          <ShimmerEffect className="lg:w-[364.12px] md:w-[224.12px] sm:w-[120.12px] h-[65.55px] mt-6 mb-0.5" />
        </div>
      </div>
      <div>
        <div className="flex justify-between items-center mb-6">
          <ShimmerEffect className="h-[31.99px] w-[31.99px] me-6" />
          <ShimmerEffect className="h-[60px] w-full" />
        </div>
      </div>
      <div>
        <div className="flex justify-between items-center">
          <ShimmerEffect className="h-[32px] w-[32px] me-6" />
          <ShimmerEffect className="h-[60px] w-full" />
        </div>
      </div>
    </div>
  );
};

export default VideosTabShimmer;
